import { useGetAdminPartners } from 'utils/web_api'

interface PartnerRelationshipSelectProps {
  employerId?: string;
}

export const PartnerRelationshipSelectImpl = ({ employerId, }: PartnerRelationshipSelectProps) => {
  const { data: partners, isLoading } = useGetAdminPartners({ employer_id: employerId })

  if (isLoading || !partners) {
    return (
      <datalist id='partners'>
        <option>
          Loading...
        </option>
      </datalist>
    )
  }

  return (
    <datalist id='partners'>
      {partners.map((partner) => (
        <option key={partner.id} value={partner.id}>
          {partner.display_name} - {partner.slug} - ({partner.relationship.fee_type}: {partner.relationship.monthly_commission_per_member})
        </option>
      ))}
    </datalist>
  )
}

const PartnerRelationshipSelect = ({ employerId, }: PartnerRelationshipSelectProps) => {
  return (
    <PartnerRelationshipSelectImpl
      employerId={employerId}
    />
  )
}

export default PartnerRelationshipSelect
